(function() {
  function cubeelandPdpText(id, fallback) {
    var el = document.getElementById('cbStr-' + id);
    return el ? (el.textContent.trim() || fallback) : fallback;
  }

  function cubeelandOnReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function cubeelandReadPdpConfig() {
    var el = document.querySelector('[data-cubeeland-pdp-config]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}') || {};
    } catch (error) {
      console.warn('Cubeeland PDP config parse failed:', error);
      return {};
    }
  }

  cubeelandOnReady(function() {
    const CUBEELAND_PDP_CONFIG = cubeelandReadPdpConfig();

    // Quantity
    window.quantity = 1;
    window.updateQuantity = function(change) {
      window.quantity = Math.max(1, (window.quantity || 1) + change);
      var qd = document.getElementById('quantity-display');
      var aq = document.getElementById('actual-shopify-quantity');
      if (qd) qd.textContent = window.quantity;
      if (aq) aq.value = window.quantity;
      if (typeof window.syncBuyNowLinks === 'function') window.syncBuyNowLinks();
      if (typeof renderGiftBanner === 'function') renderGiftBanner(lastGiftCart || fallbackGiftCart());
      if (typeof syncGiftBanner === 'function') syncGiftBanner();
    };

    // Gallery engine
    const mediaSlides = Array.from(document.querySelectorAll('.pdp-media-slide'));
    const totalImages = mediaSlides.length;
    let pdpCurrent = 0;
    const counterEl = document.getElementById('pdp-counter');
    const galleryPreloadCache = new Set();

    function cubeelandRunWhenIdle(callback, timeout) {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(callback, { timeout: timeout || 1400 });
      } else {
        window.setTimeout(callback, 450);
      }
    }

    function pdpPreloadGalleryImage(index) {
      if (!totalImages) return;
      var normalized = ((index % totalImages) + totalImages) % totalImages;
      var slide = mediaSlides[normalized];
      if (!slide) return;
      var preloadUrl = slide.getAttribute('data-preload-url');
      var img = slide.querySelector('img');
      if (!preloadUrl && img) preloadUrl = img.currentSrc || img.src;
      if (!preloadUrl || galleryPreloadCache.has(preloadUrl)) return;
      galleryPreloadCache.add(preloadUrl);
      var warmImage = new Image();
      warmImage.decoding = 'async';
      warmImage.loading = 'eager';
      warmImage.src = preloadUrl;
    }

    function pdpPrepareGalleryVideo(index) {
      if (!totalImages) return;
      var normalized = ((index % totalImages) + totalImages) % totalImages;
      var slide = mediaSlides[normalized];
      if (!slide) return;
      slide.querySelectorAll('video').forEach(function(video) {
        try {
          video.setAttribute('preload', 'auto');
          video.setAttribute('playsinline', 'playsinline');
          video.preload = 'auto';
          if (video.readyState < 2) video.load();
        } catch (e) {}
      });
    }

    function pdpPlayGalleryVideo(index) {
      if (!totalImages) return;
      var normalized = ((index % totalImages) + totalImages) % totalImages;
      var slide = mediaSlides[normalized];
      if (!slide) return;
      var video = slide.querySelector('video');
      if (!video) return;
      try {
        video.setAttribute('controls', 'controls');
        video.setAttribute('playsinline', 'playsinline');
        video.setAttribute('preload', 'auto');
        video.preload = 'auto';
        if (video.readyState < 2) video.load();
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function() {});
      } catch (e) {}
    }

    function pdpPauseInactiveMedia(activeIndex) {
      mediaSlides.forEach(function(slide, i) {
        if (i === activeIndex) return;
        slide.querySelectorAll('video').forEach(function(video) {
          try { video.pause(); } catch (e) {}
        });
        slide.querySelectorAll('iframe').forEach(function(iframe) {
          const src = iframe.getAttribute('src');
          if (src) iframe.setAttribute('src', src);
        });
      });
    }

    function pdpSyncThumbs(index) {
      document.querySelectorAll('.pdp-thumb-btn').forEach(function(btn, i) {
        const matches = (i % Math.max(totalImages, 1)) === index;
        btn.classList.toggle('is-active', matches);
        btn.setAttribute('aria-pressed', matches ? 'true' : 'false');
        if (matches) btn.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
      });
    }

    function pdpSwapImage(index) {
      if (!totalImages) return;
      mediaSlides.forEach(function(slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      pdpPauseInactiveMedia(index);
      if (counterEl) counterEl.innerHTML = (index + 1) + '&nbsp;/&nbsp;' + totalImages;
    }

    window.pdpSetImage = function(index, trigger) {
      if (!totalImages) return;
      pdpCurrent = ((index % totalImages) + totalImages) % totalImages;
      pdpPreloadGalleryImage(pdpCurrent);
      pdpPrepareGalleryVideo(pdpCurrent);
      pdpSwapImage(pdpCurrent);
      pdpSyncThumbs(pdpCurrent);
      var mediaType = trigger && typeof trigger.getAttribute === 'function' ? (trigger.getAttribute('data-media-type') || '') : '';
      if (mediaType.indexOf('video') !== -1) pdpPlayGalleryVideo(pdpCurrent);
    };
    window.pdpChangeImage = function(direction) { window.pdpSetImage(pdpCurrent + direction); };
    window.setMainImage = window.pdpSetImage;
    window.changeImage = window.pdpChangeImage;

    document.querySelectorAll('.pdp-thumb-btn[data-media-index]').forEach(function(btn) {
      var index = parseInt(btn.getAttribute('data-media-index') || '0', 10);
      btn.addEventListener('mouseenter', function() { pdpPreloadGalleryImage(index); pdpPrepareGalleryVideo(index); }, { passive: true });
      btn.addEventListener('touchstart', function() { pdpPreloadGalleryImage(index); pdpPrepareGalleryVideo(index); }, { passive: true });
      btn.addEventListener('focus', function() { pdpPreloadGalleryImage(index); pdpPrepareGalleryVideo(index); }, { passive: true });
    });

    (function() {
      const wrap = document.getElementById('pdp-main-wrap');
      if (!wrap || totalImages < 2) return;
      let tx = 0;
      wrap.addEventListener('touchstart', function(e) { tx = e.changedTouches[0].screenX; }, { passive: true });
      wrap.addEventListener('touchend', function(e) {
        const dx = e.changedTouches[0].screenX - tx;
        if (Math.abs(dx) > 40) window.pdpChangeImage(dx < 0 ? 1 : -1);
      }, { passive: true });
    })();

    // Shared mini-review slider. No-ops when the optional block is disabled.
    const sliderIntervals = new WeakMap();
    function buildDots(slides, count) {
      const containers = slides.map(function(s) { return s.querySelector('.mini-review-dots'); }).filter(Boolean);
      if (!containers.length) return [];
      const master = [];
      for (let i = 0; i < count; i++) {
        const d = document.createElement('div');
        d.className = 'mini-review-dot' + (i === 0 ? ' is-active' : '');
        master.push(d);
      }
      containers.forEach(function(c) {
        c.innerHTML = '';
        master.forEach(function(d) { c.appendChild(d.cloneNode(false)); });
      });
      return Array.from(containers[0].children);
    }
    function syncDots(slides, activeIndex) {
      slides.forEach(function(slide) {
        slide.querySelectorAll('.mini-review-dot').forEach(function(d, i) { d.classList.toggle('is-active', i === activeIndex); });
      });
    }
    function initAllSliders() {
      document.querySelectorAll('.mini-review-slider-container').forEach(function(container) {
        if (sliderIntervals.has(container)) return;
        const slides = Array.from(container.querySelectorAll('.mini-review-slide'));
        if (!slides.length) return;
        buildDots(slides, slides.length);
        slides.forEach(function(s) { s.classList.remove('is-active'); s.style.zIndex = '1'; });
        slides[0].style.transition = 'none';
        slides[0].style.zIndex = '2';
        slides[0].classList.add('is-active');
        requestAnimationFrame(function() { slides[0].style.transition = ''; });
        if (slides.length < 2) return;
        let current = 0;
        const interval = setInterval(function() {
          const next = (current + 1) % slides.length;
          slides[next].style.zIndex = '2';
          slides[current].style.zIndex = '1';
          slides[next].classList.add('is-active');
          slides[current].classList.remove('is-active');
          syncDots(slides, next);
          current = next;
        }, 4000);
        sliderIntervals.set(container, interval);
      });
    }
    cubeelandRunWhenIdle(initAllSliders, 1800);
    document.addEventListener('shopify:section:load', initAllSliders);
    document.addEventListener('shopify:block:select', initAllSliders);
    document.addEventListener('shopify:block:deselect', initAllSliders);

    // PDP gift status mirrors the single global gift engine. It never adds/removes gifts itself.
    function formatQar(cents) {
      var value = Math.max(0, Number(cents || 0)) / 100;
      return Number.isInteger(value) ? String(value) : value.toFixed(2).replace(/\.00$/, '');
    }

    var lastGiftCart = null;
    function fallbackGiftCart() {
      var engine = document.getElementById('cg-gift-engine');
      return { subtotal: Math.max(0, Number(engine && engine.getAttribute('data-initial-eligible-cart-cents') || 0)), threshold: Math.max(0, Number(engine && engine.getAttribute('data-threshold-qar') || 90) * 100) };
    }

    function renderGiftBanner(result) {
      var giftBanner = document.getElementById('gift-banner-wrapper');
      if (!giftBanner || !result) return;
      var preContent = document.getElementById('gift-pre-content');
      var unlockedContent = document.getElementById('gift-unlocked-content');
      var msgEl = document.getElementById('gift-progress-message');
      var baseSubtotal = Math.max(0, Number(result.subtotal || 0));
      var productPrice = Math.max(0, Number(giftBanner.getAttribute('data-product-price') || 0));
      var qtyInput = document.getElementById('actual-shopify-quantity');
      var productQty = Math.max(1, Number(qtyInput && qtyInput.value || 1));
      var projectedSubtotal = baseSubtotal + productPrice * productQty;
      var threshold = Math.max(0, Number(result.threshold || giftBanner.getAttribute('data-threshold') || 9000));
      var eligible = projectedSubtotal >= threshold;
      result = Object.assign({}, result, { eligible: eligible, remaining: Math.max(0, threshold - projectedSubtotal) });
      giftBanner.classList.toggle('gift-banner-state-unlocked', eligible);
      giftBanner.classList.toggle('gift-banner-state-pre', !eligible);
      if (preContent) preContent.style.display = eligible ? 'none' : 'block';
      if (unlockedContent) unlockedContent.style.display = eligible ? 'block' : 'none';
      if (msgEl && !eligible) {
        var amountText = formatQar(result.remaining);
        var template = msgEl.getAttribute('data-template') || cubeelandPdpText('giftProgressFallback', 'Add QAR __AMOUNT__ more to get your free gift.');
        msgEl.textContent = template.replace(/__AMOUNT__/g, amountText).replace(/\[amount\]/g, amountText).replace(/\[مبلغ\]/g, amountText);
      }
    }

    function syncGiftBanner() {
      renderGiftBanner(lastGiftCart || fallbackGiftCart());
      if (!window.CubeelandFreeGiftEngine || typeof window.CubeelandFreeGiftEngine.sync !== 'function') return;
      window.CubeelandFreeGiftEngine.sync({ notify: false }).then(function(result) { if (result) { lastGiftCart = result; renderGiftBanner(result); } });
    }
    document.addEventListener('cubeeland:free-gift-updated', function(event) {
      if (event && event.detail) { lastGiftCart = event.detail; renderGiftBanner(event.detail); }
      else syncGiftBanner();
    });
    document.addEventListener('cart:updated', syncGiftBanner);
    document.addEventListener('cart:refresh', syncGiftBanner);
    window.setTimeout(syncGiftBanner, 250);

    // Accordions
    window.toggleAccordion = function(id) {
      const content = document.getElementById(id + '-content');
      const icon = document.getElementById(id + '-icon');
      const btn = document.getElementById(id + '-btn');
      if (!content) return;
      const isOpen = !content.classList.contains('max-h-0');
      if (isOpen) {
        content.classList.add('max-h-0', 'opacity-0');
        content.classList.remove('max-h-96', 'opacity-100');
        if (icon) icon.classList.remove('rotate-180');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      } else {
        content.classList.remove('max-h-0', 'opacity-0');
        content.classList.add('max-h-96', 'opacity-100');
        if (icon) icon.classList.add('rotate-180');
        if (btn) btn.setAttribute('aria-expanded', 'true');
      }
    };

    window.togglePdpAccordion = function(header) {
      const item = header.closest('.pdp-accordion-item');
      if (!item) return;
      item.classList.toggle('is-active');
      header.setAttribute('aria-expanded', item.classList.contains('is-active') ? 'true' : 'false');
    };

    // Custom video cards
    function cubeelandShowVideoOverlay(video) {
      const card = video && video.closest('.cubeeland-video-card');
      if (!card) return;
      const overlay = card.querySelector('.play-btn-overlay');
      card.classList.remove('is-playing');
      video.removeAttribute('controls');
      if (overlay) overlay.classList.remove('opacity-0', 'pointer-events-none');
    }

    function cubeelandHideVideoOverlay(video) {
      const card = video && video.closest('.cubeeland-video-card');
      if (!card) return;
      const overlay = card.querySelector('.play-btn-overlay');
      card.classList.add('is-playing');
      video.setAttribute('controls', 'controls');
      if (overlay) overlay.classList.add('opacity-0', 'pointer-events-none');
    }

    window.toggleCustomVideo = function(container) {
      const video = container ? container.querySelector('video') : null;
      if (!video) return;
      document.querySelectorAll('.cubeeland-custom-video').forEach(function(otherVideo) {
        if (otherVideo !== video) {
          try { otherVideo.pause(); } catch (e) {}
          cubeelandShowVideoOverlay(otherVideo);
        }
      });
      if (video.paused) {
        const playPromise = video.play();
        cubeelandHideVideoOverlay(video);
        if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function() { video.setAttribute('controls', 'controls'); });
      } else {
        video.pause();
        cubeelandShowVideoOverlay(video);
      }
    };

    document.querySelectorAll('.cubeeland-custom-video').forEach(function(video) {
      video.addEventListener('play', function() { cubeelandHideVideoOverlay(video); });
      video.addEventListener('pause', function() { cubeelandShowVideoOverlay(video); });
    });

    // The global engine owns gift notices and checkout state.
    window.addEventListener('pageshow', function() {
      try {
        if (window.CubeelandFreeGiftEngine && typeof window.CubeelandFreeGiftEngine.closeNotice === 'function') {
          window.CubeelandFreeGiftEngine.closeNotice();
        }
      } catch (e) {}
    });

    // Product information modal used by the gift-banner detail link.
    function openModal(modalId, contentId) {
      const modal = document.getElementById(modalId);
      const content = document.getElementById(contentId);
      if (!modal) return;
      modal.classList.remove('hidden');
      modal.classList.add('flex');
      setTimeout(function() {
        modal.classList.remove('opacity-0');
        if (content) {
          content.classList.remove('scale-95');
          content.classList.add('scale-100');
        }
      }, 10);
    }

    function closeModal(modalId, contentId) {
      const modal = document.getElementById(modalId);
      const content = document.getElementById(contentId);
      if (!modal) return;
      modal.classList.add('opacity-0');
      if (content) {
        content.classList.remove('scale-100');
        content.classList.add('scale-95');
      }
      setTimeout(function() {
        modal.classList.add('hidden');
        modal.classList.remove('flex');
      }, 300);
    }
    window.openGiftModal = function() { openModal('gift-modal', 'gift-modal-content'); };
    window.closeGiftModal = function() { closeModal('gift-modal', 'gift-modal-content'); };

    // WhatsApp
    window.buyOnWhatsApp = function() {
      const qty = Math.max(1, window.quantity || 1);
      const productTitle = CUBEELAND_PDP_CONFIG.productTitle || '';
      const template = CUBEELAND_PDP_CONFIG.whatsappPrefillTextWithQuantity || cubeelandPdpText('whatsappFallback', "Hi, I'm interested in buying [quantity]x [product_title].");
      const msgText = template.replace(/\[quantity\]/g, qty).replace(/\[product_title\]/g, productTitle);
      window.open('https://wa.me/' + encodeURIComponent(CUBEELAND_PDP_CONFIG.whatsappNumber || '') + '?text=' + encodeURIComponent(msgText), '_blank');
    };

    // Sticky bottom purchase bar
    window.addEventListener('scroll', function() {
      const buySection = document.getElementById('buy-buttons-section');
      const stickyBar = document.getElementById('sticky-bottom-bar');
      const floatingWa = document.getElementById('floating-wa');
      if (buySection && stickyBar) {
        const rect = buySection.getBoundingClientRect();
        if (rect.bottom < 0) {
          stickyBar.classList.remove('translate-y-full');
          if (floatingWa) {
            floatingWa.classList.replace('bottom-4', 'bottom-20');
            floatingWa.classList.replace('md:bottom-6', 'md:bottom-20');
          }
        } else {
          stickyBar.classList.add('translate-y-full');
          if (floatingWa) {
            floatingWa.classList.replace('bottom-20', 'bottom-4');
            floatingWa.classList.replace('md:bottom-20', 'md:bottom-6');
          }
        }
      }
    }, { passive: true });
  });
})();